import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { NotificationService } from '@vasta/frontend-ui-feedback';
import { SKIP_ERROR_TOAST } from './skip-error-toast.token';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notification = inject(NotificationService);
  const transloco = inject(TranslocoService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        // The public page and the publication dialog ask for things that may
        // legitimately not exist yet; those 404/401 answers have their own
        // empty states and must not raise a global toast.
        const isExpected =
          req.url.includes('/public/') ||
          (err.status === 404 && req.url.includes('/schedule-publications/'));

        if (!isExpected && !req.context.get(SKIP_ERROR_TOAST)) {
          const code: string | undefined = (err.error as { code?: string })
            ?.code;
          const key = code ? `errors.${code}` : null;
          const translated = key ? transloco.translate(key) : null;
          const isTranslated = translated && translated !== key;

          const summary = transloco.translate('errors.title');
          const detail = isTranslated
            ? translated
            : transloco.translate('errors.generic');

          notification.error(summary, detail);
        }
      }

      return throwError(() => err);
    }),
  );
};
